module.exports = __webpack_public_path__ + "img/sw1-b4.a0ca5b82.jpg";